import { render, staticRenderFns } from "./DadosDoClienteAdmin.vue?vue&type=template&id=378fa646&scoped=true"
import script from "./DadosDoClienteAdmin.vue?vue&type=script&lang=js"
export * from "./DadosDoClienteAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378fa646",
  null
  
)

export default component.exports